import { Chip } from "@mui/material";

import { PieceBackfillRunStatus } from "../../generated/graphql";

type ChipColor = "default" | "info" | "success" | "error";

const STATUS_COLORS: Record<PieceBackfillRunStatus, ChipColor> = {
  [PieceBackfillRunStatus.Pending]: "default",
  [PieceBackfillRunStatus.Running]: "info",
  [PieceBackfillRunStatus.Completed]: "success",
  [PieceBackfillRunStatus.Failed]: "error",
};

const STATUS_LABELS: Record<PieceBackfillRunStatus, string> = {
  [PieceBackfillRunStatus.Pending]: "queued",
  [PieceBackfillRunStatus.Running]: "running",
  [PieceBackfillRunStatus.Completed]: "completed",
  [PieceBackfillRunStatus.Failed]: "failed",
};

/** Props for {@link PieceBackfillStatusChip}. */
export type PieceBackfillStatusChipProps = {
  /** The run's status. */
  readonly status: PieceBackfillRunStatus;
};

/**
 * Status chip for a backfill run, shared by the live progress panel and the run
 * history table so a status never reads differently in the two places.
 */
const PieceBackfillStatusChip = ({ status }: PieceBackfillStatusChipProps) => {
  return (
    <Chip
      color={STATUS_COLORS[status]}
      label={STATUS_LABELS[status]}
      size="small"
    />
  );
};

export default PieceBackfillStatusChip;
